'use client'

import { ReactNode } from 'react'

import { cn } from '@/shared/lib/utils'

interface BodyProps {
  noClasses?: boolean
  className?: string
  children: ReactNode
}

export const Body = ({
  noClasses = false,
  className = '',
  children
}: BodyProps) => {
  return (
    <div
      id="level-play-body"
      className={cn(
        'min-h-0',
        'overflow-y-auto',
        {
          'mx-auto w-[92%] px-2': !noClasses,
          'w-full': noClasses
        },
        className
      )}
    >
      {children}
    </div>
  )
}
